export const dynamicCheckboxCss = ({ buttonColor, buttonTextColor }: { buttonColor: string; buttonTextColor: string }) => {
  const dynamicCss = `
  .controlled-checkbox:checked {
    border-color: ${buttonColor} !important;
    background-color: ${buttonColor} !important;
    visibility: visible !important;
    margin-bottom: 0 !important;
  }
  .controlled-checkbox {
    position: relative !important;
    width: 20px !important;
    height: 20px !important;
    cursor: pointer !important;
    appearance: none !important;
    border-radius: 4px !important;
    border: 1px solid #cbd5e0 !important;
    transition: all 0.3s !important;
    visibility: visible !important;
    margin-bottom: 0 !important;
  }
  
  .controlled-checkbox::before {
    content: '' !important;
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    display: block !important;
    height: 12px !important;
    width: 12px !important;
    transform: translate(-50%, -50%) !important;
    border-radius: 50% !important;
    background-color: ${buttonColor}!important;
    opacity: 0 !important;
    transition: opacity 0.3s !important;
    visibility: visible !important;
    margin-bottom: 0 !important;
  }
  
  .controlled-checkbox:checked {
    border-color: ${buttonColor} !important;
    background-color: ${buttonColor} !important;
    visibility: visible !important;
    margin-bottom: 0 !important;
  }
  
  .controlled-checkbox:checked::before {
    background-color: ${buttonColor} !important;
    opacity: 1 !important;
    visibility: visible !important;
    margin-bottom: 0 !important;
  }
  
  .controlled-checkbox:hover::before {
    opacity: 0.1 !important;
    visibility: visible !important;
    margin-bottom: 0 !important;
  }
  
  .controlled-checkbox:checked::after {
    content: '\\2713' !important;
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    font-size: 14px !important;
    color: ${buttonTextColor} !important;
  }
  `;

  return dynamicCss;
};
